import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiSubscriptionCreate = async (jsonData) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.message || 'Erro ao criar assinatura');
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionList = async (filters) => {
  try {
    const response = await authorizedFetch(urlFilters(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans`, filters), {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionDetail = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${id}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionDelete = async (id) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${id}`, {
      method: "DELETE",
      headers: buildHeaders(),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionUpdate = async (id, jsonData) => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${id}/`, {
      method: "PUT",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.message || 'Erro ao atualizar assinatura');
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionPlanDetails = async (planId) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/subscriptions/plan/${planId}/`, {
      method: "GET",
      headers: buildHeaders(),
    });

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.message || 'Erro ao buscar detalhes do plano');
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionSubscribe = async (planId, jsonData) => {
  try {
    const response = await fetch(`${baseSiteEndPoint}/subscriptions/plan/${planId}/subscribe/`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(jsonData)
    });

    const data = await response.json();

    return {
      ...data,
      httpStatus: response.status,
      httpStatusText: response.statusText
    };
  } catch (error) {
    throw error;
  }
};

// Subscribers API
export const apiSubscribersList = async (planId, filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${planId}/subscribers/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiSubscriberDetail = async (planId, subscriberId) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${planId}/subscribers/${subscriberId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

// Subscription Payments API
export const apiSubscriptionPaymentsList = async (planId, subscriberId, filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(
        `${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${planId}/subscribers/${subscriberId}/payments/`,
        filters
      ),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiSubscriptionPaymentDetail = async (planId, subscriberId, paymentId) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${planId}/subscribers/${subscriberId}/payments/${paymentId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

// Admin cancel subscriber
export const apiAdminSubscriberCancel = async (planId, subscriberId) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/subscriptions/seller/${getSellerID()}/plans/${planId}/subscribers/${subscriberId}/cancel/`,
      {
        method: "POST",
        headers: buildHeaders(),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.message || 'Erro ao cancelar assinatura');
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Public endpoints (no authentication required)

// Get subscriber details (public)
export const apiPublicSubscriberDetail = async (subscriberId) => {
  try {
    const response = await fetch(
      `${baseSiteEndPoint}/subscriptions/subscriber/${subscriberId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.detail || errorResponse.error || errorResponse.message || 'Erro ao buscar detalhes do assinante');
      error.code = errorResponse.code;
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Self-cancel subscription (public)
export const apiPublicSubscriberCancel = async (subscriberId) => {
  try {
    const response = await fetch(
      `${baseSiteEndPoint}/subscriptions/subscriber/${subscriberId}/cancel/`,
      {
        method: "POST",
        headers: buildHeaders(),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.detail || errorResponse.error || errorResponse.message || 'Erro ao cancelar assinatura');
      error.code = errorResponse.code;
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Get payment details (public)
export const apiPublicPaymentDetail = async (subscriberId, paymentId) => {
  try {
    const response = await fetch(
      `${baseSiteEndPoint}/subscriptions/subscriber/${subscriberId}/payment/${paymentId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      const error = new Error(errorResponse.detail || errorResponse.error || errorResponse.message || 'Erro ao buscar detalhes do pagamento');
      error.code = errorResponse.code;
      error.status = response.status;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Pay pending payment (public)
export const apiPublicPaymentPay = async (subscriberId, paymentId, jsonData) => {
  try {
    const response = await fetch(
      `${baseSiteEndPoint}/subscriptions/subscriber/${subscriberId}/payment/${paymentId}/pay/`,
      {
        method: "POST",
        headers: buildHeaders(),
        body: JSON.stringify(jsonData),
      }
    );

    const data = await response.json();

    return {
      ...data,
      httpStatus: response.status,
      httpStatusText: response.statusText,
    };
  } catch (error) {
    throw error;
  }
};
